import template from './users.html';
import controller from './users.controller';
import './users.scss';

let usersComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default usersComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/users/users.component.js